// extracted by mini-css-extract-plugin
module.exports = {"observedBadge":"ObservedBadge_observedBadge__Zy5ob","small":"ObservedBadge_small___AO5V","medium":"ObservedBadge_medium___Sjfu"};